import { queryToString } from '@shared/helpers/api-utils';
import constructErrorResponse, { ErrorResponseType } from '../errorResponse';
import axios, { AxiosError } from '@shared/helpers/axios';

export const apiPath = 'api/v2/chat-messages';

export interface ChatMessageType {
    id?: number;
    chatRoomId?: number;
    senderId?: number;
    receiverId?: number;
    message?: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface ChatRoomType {
    id: number;
    chatRoomId: number;
    chatMessages?: ChatMessageType[];
}

interface MutateResponseType {
    data: ChatMessageType | ChatRoomType | undefined;
    error: ErrorResponseType | undefined;
}

export const index = async (queries: Record<string, any>): Promise<MutateResponseType> => {
    let response: MutateResponseType = {
        data: undefined,
        error: undefined,
    };

    try {
        const url = `${process.env.REACT_APP_API_URL}/${apiPath}/index?${queryToString(queries)}`;
        const { data } = await axios.get(url, {
            timeout: 30000,
        });
        response.data = data;
    } catch (error) {
        const axiosError = error as AxiosError;
        let errorMessage = axiosError.response?.data || 'network error';
        let errorStatus = axiosError.response?.status;

        if (typeof errorMessage !== 'string' && errorMessage.error)
            errorMessage = axiosError.response?.data?.error?.cause;

        response.error = constructErrorResponse({
            errorMessage,
            errorStatus,
        });
    }
    return response;
};

export const sendMessage = async (entity: {
    receiverId: number;
    message: string;
    withContext?: boolean;
    professionalServiceId?: number;
    professionDetailId?: number;
    surveyRequestId?: number;
    professionalOrderDetailId?: number;
}): Promise<MutateResponseType> => {
    let response: MutateResponseType = {
        data: undefined,
        error: undefined,
    };

    try {
        const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/${apiPath}/send`, {
            ...entity,
        });
        response.data = data;
    } catch (error) {
        const axiosError = error as AxiosError;
        let errorMessage = axiosError.response?.data || 'network error';
        let errorStatus = axiosError.response?.status;

        if (typeof errorMessage !== 'string' && errorMessage.error)
            errorMessage = axiosError.response?.data?.error?.cause;

        response.error = constructErrorResponse({
            errorMessage,
            errorStatus,
        });
    }
    return response;
};

const chatMessageApi = {
    index,
    sendMessage,
};

export default chatMessageApi;
